import { render } from "./icon-clipboard-checkmark.svg?vue&type=template&id=137166d0"
const script = {}

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__